import { __decorate } from "tslib";
import { Component, Vue, Model, Prop, Watch } from "vue-property-decorator";
let PiSelectTableData = class PiSelectTableData extends Vue {
    constructor() {
        super(...arguments);
        this.all = false;
        this.selectValue = [];
        this.exportSelectValue = [];
        this.modalShow = false;
        this.exportModalShow = false;
    }
    getVisible() {
        this.initData();
    }
    openModal() {
        this.modalShow = true;
    }
    /**
     * 多选选择
     */
    checkChange(val) {
        const arr = [];
        this.allTableData.map((item) => {
            if (val.indexOf(item.key) != -1) {
                arr.push(item);
            }
        });
        this.$emit("value", arr);
    }
    /**
     * 全选
     */
    allChange(val) {
        const arr = [];
        const selectValue = [];
        if (val) {
            this.allTableData.map((item) => {
                arr.push(item);
                selectValue.push(item.key);
            });
        }
        this.selectValue = selectValue;
        this.$emit("value", arr);
    }
    /**
     * 刷新点击
     */
    getTable() {
        this.$emit("get");
    }
    // public queryClick(): void {
    //   this.$emit("query");
    // }
    /**
     * 导出、现在没有用到了
     */
    exportCheckChange(val) {
        this.$emit("exportChange", val);
    }
    /**
     * 初始化
     */
    initData() {
        const arr = [];
        const selectValue = [];
        this.allTableData.map((item) => {
            if (item.show === true || item.show === undefined) {
                arr.push(item);
                selectValue.push(item.key);
            }
        });
        this.selectValue = selectValue;
        this.exportSelectValue = selectValue;
        this.$emit("value", arr);
    }
    mounted() {
        this.initData();
    }
};
__decorate([
    Prop({ default: true })
], PiSelectTableData.prototype, "getShow", void 0);
__decorate([
    Prop({ default: true })
], PiSelectTableData.prototype, "modalBtnShow", void 0);
__decorate([
    Prop({ default: false })
], PiSelectTableData.prototype, "queryShow", void 0);
__decorate([
    Prop({ default: false })
], PiSelectTableData.prototype, "exportBtn", void 0);
__decorate([
    Prop({
        default: () => {
            return [];
        },
    })
], PiSelectTableData.prototype, "allTableData", void 0);
__decorate([
    Model("value", { type: Array })
], PiSelectTableData.prototype, "modelValue", void 0);
__decorate([
    Watch("allTableData")
], PiSelectTableData.prototype, "getVisible", null);
PiSelectTableData = __decorate([
    Component({
        components: {},
    })
], PiSelectTableData);
export default PiSelectTableData;
